import { AlertTriangle } from 'lucide-react';
import { useI18n } from '../i18n';

/* Small, reusable caution note shown next to AI-generated content.
 * Reminds users that AI can be wrong and they should double-check. */
export default function AiCaution({ className = '' }) {
    const { t } = useI18n();
    return (
        <div
            data-testid="ai-caution"
            className={`flex items-start gap-2 text-[11px] leading-relaxed text-brand-ink3 bg-brand-ochre/10 border border-brand-ochre/30 rounded-2xl px-3 py-2 ${className}`}
        >
            <AlertTriangle size={13} strokeWidth={1.8} className="flex-shrink-0 mt-0.5 text-brand-ochre" />
            <span>{t('common.ai_caution')}</span>
        </div>
    );
}
